import pluralize from "pluralize";

export enum WorkbenchUnit {
    DECK = "deck",
    SLIDE = "slide",
}

export const getWorkbenchLabel = (
    label: string,
    count: number,
    unit: WorkbenchUnit,
): string => {
    if (count > 0) {
        return `${label} with ${pluralize(unit, count, true)}`;
    } else {
        return label;
    }
};
